import toastr from 'toastr';
import parseFailXhr from './parse-fail-xhr';

export default function defaultOnErrorHandler(e, message) {
  // eslint-disable-next-line no-console
  console.log('defaultOnErrorHandler', e);
  const errors = parseFailXhr(e.jqXHR);

  if (!errors.anyUnhandledErrors()) return;

  toastr.error(errors.getErrorSummary(), message);
}
